// extracted by mini-css-extract-plugin
export default {"root":"DetailPageViewCard_root__9c1aL"};